module.exports = __webpack_public_path__ + "static/media/3.8954a0ff.jpg";